import React, { useEffect, useState } from "react";
import { OuterContainer } from "../../../EventCreation/styles";
import styled from "styled-components";
import theme from "../../../../assets/theme";
import { PrimaryCTAButton } from "../../../common/Buttons";
import COLORS from "../../../../assets/Colors";
import { CheckboxContainer, CustomCheckBox } from "../../../common/FormInputs";
import EventService from "../../../../services/EventService";
import AnswerModal from "../../../schedules/QandADashboard/AnswerModal";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import { getErrorMessage } from "../../../../helpers/functions";
import { generateDOCX } from "../../../schedules/generatePdf";

const QandA = ({ eventId }) => {
  const [state, setState] = useState([]);
  const [modal, setModal] = useState({ state: false });
  const [viewer, setViewer] = useState();
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedId, setSelectedId] = useState([]);
  const [pdfData, setPdfData] = useState([]);

  const formatedDate = (utc) => {
    const utcTime = new Date(utc);

    // Options for formatting the date
    const options = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    // Convert UTC time to the desired format
    const formattedDateString = utcTime.toLocaleDateString("en-US", options);

    // setFormattedDate(formattedDateString);
    return formattedDateString;
  };

  useEffect(() => {
    async function getQnADashboard(eventId) {
      try {
        setLoader({ state: true, message: "Fetching..." });
        const response = await EventService.getqadashboard(eventId);
        setViewer(response?.data?.eventDetails);
        setPdfData(response?.data);
        if (response) {
          setState(
            response?.data?.questionsDetails?.map((item) => ({
              header: [
                {
                  name: "",
                  label: "Name",
                  value: item?.viewerDetails?.viewerName,
                },
                response?.data?.eventDetails.eventTemplate === "AGM" ?
                  {
                    name: "",
                    label: "DPClientId",
                    value: item?.viewerDetails?.viewerDPClientId,
                  }
                  : {
                    name: "",
                    label: "Company",
                    value: item?.viewerDetails?.viewerCompanyName,
                  },
                {
                  name: "",
                  label: "Email",
                  value: item?.viewerDetails?.viewerEmail,
                },
              ],
              body: ["Question", formatedDate(item?.sendDate)],
              bodyText: item?.messageText,
              questionId: item?.questionId,
              chekbox: ["Select"],
              buttons: ["Mark Read", "Answer"],
              answerDetails: item?.answerDetails,
              answeredStatus: item?.answeredStatus,
              readStatus: item?.readStatus,
              viewerId: item?.viewerDetails?.viewerId,
            })),
          );
        }
      } catch (err) {
        const message = getErrorMessage(err);
        enqueueSnackbar(message, {
          variant: "error",
        });
      } finally {
        setLoader({ state: false });
      }
    }
    if (eventId) {
      getQnADashboard(eventId);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (eventId) {
      const interval = setInterval(() => {
        (async function getQnADashboard() {
          try {
            const response = await EventService.getqadashboard(eventId);
            setViewer(response?.data?.eventDetails);
            setPdfData(response?.data);
            if (response) {
              setState(
                response?.data?.questionsDetails?.map((item) => ({
                  header: [
                    {
                      name: "",
                      label: "Name",
                      value: item?.viewerDetails?.viewerName,
                    },
                    response?.data?.eventDetails.eventTemplate === "AGM" ?
                    {
                      name: "",
                      label: "DPClientId",
                      value: item?.viewerDetails?.viewerDPClientId,
                    }
                    : {
                      name: "",
                      label: "Company",
                      value: item?.viewerDetails?.viewerCompanyName,
                    },
                    {
                      name: "",
                      label: "Email",
                      value: item?.viewerDetails?.viewerEmail,
                    },
                  ],
                  body: ["Question", formatedDate(item?.sendDate)],
                  bodyText: item?.messageText,
                  questionId: item?.questionId,
                  chekbox: ["Select"],
                  buttons: ["Mark Read", "Answer"],
                  answerDetails: item?.answerDetails,
                  answeredStatus: item?.answeredStatus,
                  readStatus: item?.readStatus,
                  viewerId: item?.viewerDetails?.viewerId,
                })),
              );
            }
          } catch (err) {}
        })();
      }, 2000);
      return () => clearInterval(interval);
    }
  }, [eventId]); // eslint-disable-line react-hooks/exhaustive-deps

  const buttons = [
    {
      name: "printSelected",
      label: "Print Selected",
      type: "primary",
    },
    {
      name: "answeredStatus",
      label: "Mark Answered Selected",
      type: "primary",
    },
    {
      name: "readStatus",
      label: "Mark Read Selected",
      type: "primary",
    },
    {
      name: "deleteStatus",
      label: "Delete Selected",
      type: "primary",
    },
    {
      name: "download",
      label: "Download All",
      type: "primary",
    },
  ];

  /**
   * @description Mark read status
   */

  async function updateQandA(questionId) {
    try {
      setLoader({ state: true, message: "update status..." });
      const payload = {
        questionId: selectedId?.length
          ? selectedId.filter((id) => id === questionId)
          : [questionId],
        readStatus: true,
      };
      const response = await EventService.updateQandA(eventId, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
    }
  }

  /**
   * @description onFormSubmit function
   */

  async function onFormSubmit(status, selected) {
    try {
      setLoader({ state: true, message: "update status..." });
      const payload = {
        questionId: selectedId,
        [status]: selected,
      };
      const response = await EventService.updateQandA(eventId, payload);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
    } catch (err) {
      enqueueSnackbar(err?.message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setSelectedId([]);
    }
  }

  return (
    <OuterContainer disabled={false}>
      <Container>
        <ButtonContainer>
          {buttons.map((button) => (
            <PrimaryCTAButton
              style={{
                width: "auto",
                marginLeft: 10,
                display:
                  button.name === "readStatus" && !selectedId?.length
                    ? "none"
                    : button.name === "deleteStatus" && !selectedId?.length
                    ? "none"
                    : button.name === "answeredStatus" && !selectedId?.length
                    ? "none"
                    : button.name === "printSelected" && !selectedId?.length
                    ? "none"
                    : "",
              }}
              onClick={() =>
                button.name === "readStatus"
                  ? onFormSubmit("readStatus", true)
                  : button.name === "deleteStatus"
                  ? onFormSubmit("deleteStatus", true)
                  : button.name === "answeredStatus"
                  ? onFormSubmit("answeredStatus", true)
                  : button.name === "download"
                  ? state?.length
                    ? generateDOCX(pdfData, "download")
                    : ""
                  : state?.length
                  ? generateDOCX({
                      questionsDetails: pdfData?.questionsDetails?.filter(
                        (item) => selectedId?.includes(item?.questionId),
                      ),
                      eventDetails: pdfData?.eventDetails,
                    })
                  : ""
              }
            >
              {button.label}
            </PrimaryCTAButton>
          ))}
        </ButtonContainer>
        {state?.map((item) => (
          <QuestionContainer>
            <InnerContainer>
              <CardHeader>
                {item.header.map((arr) => (
                  <LabelContainer style={{ display: "flex" }}>
                    <Label>{arr.label}</Label> : <Value>{arr.value}</Value>
                  </LabelContainer>
                ))}
              </CardHeader>
              <CardBody>
                <CardHeader>
                  {item.body.map((arr) => (
                    <LabelContainer>
                      <Label>{arr}</Label>
                    </LabelContainer>
                  ))}
                </CardHeader>
                <Paragraph>{item.bodyText}</Paragraph>
              </CardBody>
              <CardBody>
                <AnswerHeader>
                  {item.answerDetails.map((arr, index) => (
                    <LabelContainer style={{ margin: "0 0px 10px" }}>
                      <Label>
                        {index + 1}. {"Answer"}
                      </Label>
                      <Paragraph style={{ margin: "0 15px 10px" }}>
                        {arr.messageText}
                      </Paragraph>
                    </LabelContainer>
                  ))}
                </AnswerHeader>
              </CardBody>
            </InnerContainer>
            <LeftContainer>
              {item?.chekbox?.map((arr) => (
                <CheckboxContainer>
                  <CustomCheckBox
                    checked={selectedId.includes(item?.questionId)}
                    onChange={() =>
                      setSelectedId((prev) => {
                        // Check if the viewer with the same ID already exists
                        const exists = prev.some(
                          (obj) => obj === item.questionId,
                        );

                        if (exists) {
                          // Remove the viewer by filtering it out
                          return prev.filter((obj) => obj !== item?.questionId);
                        } else {
                          // Add the new viewer
                          return [...prev, item?.questionId];
                        }
                      })
                    }
                  />
                  <CheckBoxLabel>{arr}</CheckBoxLabel>
                </CheckboxContainer>
              ))}
              <CardBody>
                {item.buttons.map((button) => (
                  <PrimaryCTAButton
                    style={{
                      width: "150px",
                      marginBottom: 10,
                      display:
                        button === "Mark Read"
                          ? item?.readStatus && "none"
                          : "",
                    }}
                    onClick={() =>
                      button === "Answer"
                        ? setModal({
                            state: true,
                            questionId: item.questionId,
                            viewerId: item?.viewerId,
                          })
                        : updateQandA(item?.questionId)
                    }
                  >
                    {button}
                  </PrimaryCTAButton>
                ))}
              </CardBody>
            </LeftContainer>
          </QuestionContainer>
        ))}
      </Container>
      {modal && <AnswerModal {...{ modal, setModal, viewer }} />}
    </OuterContainer>
  );
};

export default QandA;

const Container = styled.div`
  padding: 35px 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  @media ${theme?.breakpoints?.sm_up} {
  }
`;

const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 12px;
  @media ${theme?.breakpoints?.sm_up} {
    display: flex;
  }
`;
const QuestionContainer = styled.div`
  width: 100%;
  margin-top: 25px;
  background-color: #ffffff;
  border-radius: 10px;
  @media ${theme?.breakpoints?.sm_up} {
    display: flex;
  }
`;

const InnerContainer = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px 10px;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 15px 10px;
  }
`;

const CardHeader = styled.div`
  justify-content: space-between;
  margin-bottom: 15px;
  @media ${theme?.breakpoints?.sm_up} {
    display: flex;
  }
`;

const CardBody = styled.div`
  margin: 10px 0;
`;

const LeftContainer = styled.div`
  width: 15%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 15px 10px;
  @media ${theme?.breakpoints?.sm_up} {
    padding: 15px 10px;
  }
`;

const LabelContainer = styled.div``;

const Label = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.INPUT_LABEL};
`;

const Value = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
  margin-left: 5px;
`;

const Paragraph = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
`;

const CheckBoxLabel = styled.span`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 15px;
  color: #293461;
`;

const AnswerHeader = styled.div`
  justify-content: space-between;
  margin-bottom: 15px;
`;
